"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-unused-vars
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
// eslint-disable-next-line no-unused-vars
const lucide_vue_next_1 = require("lucide-vue-next");
// eslint-disable-next-line no-unused-vars
const SidebarResult_vue_1 = __importDefault(require("@becrop/components/Results/Layout/SidebarResult.vue"));
// eslint-disable-next-line no-unused-vars
const TopbarResult_vue_1 = __importDefault(require("@becrop/components/Results/Layout/TopbarResult.vue"));
// eslint-disable-next-line no-unused-vars
const TableSummaryProposalsDetail_vue_1 = __importDefault(require("@becrop/components/Results/TableSummaryProposalsDetail.vue"));
const AreaController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/AreaController"));
let ResultsAreaListView = class ResultsAreaListView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.service = new AreaController_1.default();
        this.textSearch = '';
        this.filterSearchActive = '';
        this.typeCard = 'big'; // big or small
        this.areasOrder = [];
    }
    created() {
        this.service.fetchAllAreas('results/areas');
    }
    get allAreas() {
        return this.service.areas;
    }
    get allAreasOngoing() {
        this.service.ongoing();
        return this.service.areasOngoing;
    }
    get filtersAreas() {
        this.service.filter(this.textSearch);
        return this.service.areasFilter;
    }
    get paginatedAreas() {
        this.service.filter(this.textSearch);
        return this.service.areasPaginated();
    }
    loadPage(page) {
        this.service.setCurrentPage(page);
    }
    launchCrumb(name) {
        this.$emit('launchcrumb', name);
    }
    activeSelector(activeValue) {
        this.filterSearchActive = activeValue;
    }
    onchangesearch(text) {
        this.textSearch = text;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
    // eslint-disable-next-line camelcase
], ResultsAreaListView.prototype, "raw_would_rather_crops", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
    // eslint-disable-next-line camelcase
], ResultsAreaListView.prototype, "raw_user", void 0);
ResultsAreaListView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            StandardTemplate: bmk_ui_framework_1.StandardTemplate,
            SidebarResult: SidebarResult_vue_1.default,
            TopbarResult: TopbarResult_vue_1.default,
            Yield: bmk_ui_framework_1.Yield,
            Breadcrumbs: bmk_ui_framework_1.Breadcrumbs,
            HomeIcon: bmk_ui_framework_1.HomeIcon,
            PageHeading: bmk_ui_framework_1.PageHeading,
            ParcelsIcon: bmk_ui_framework_1.ParcelsIcon,
            Separator: bmk_ui_framework_1.Separator,
            BreadcrumbsItem: bmk_ui_framework_1.BreadcrumbsItem,
            TableSummaryProposalDetail: TableSummaryProposalsDetail_vue_1.default,
            ResultModuleCardArea: bmk_ui_framework_1.ResultModuleCardArea,
            GroupAreas: bmk_ui_framework_1.GroupAreas,
            Zap: lucide_vue_next_1.Zap,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
            MagnifyingGlassIcon: bmk_ui_framework_1.MagnifyingGlassIcon,
            ViewZero: bmk_ui_framework_1.ViewZero,
            LayoutList: lucide_vue_next_1.LayoutList,
            LayoutGrid: lucide_vue_next_1.LayoutGrid,
            Button: bmk_ui_framework_1.Button,
            Loader: bmk_ui_framework_1.Loader,
            Pagination: bmk_ui_framework_1.Pagination,
            MapPin: lucide_vue_next_1.MapPin,
            Modal: bmk_ui_framework_1.Modal,
            Plus: lucide_vue_next_1.Plus,
            Minus: lucide_vue_next_1.Minus,
            X: lucide_vue_next_1.X,
        },
    })
    // eslint-disable-next-line no-unused-vars
], ResultsAreaListView);
exports.default = ResultsAreaListView;
